<template>
  <div class="container">
    <div class="space-bottom-1 pt-4">
      <i class="fa fa-arrow-left text-primary" aria-hidden="true"></i>
      <a href="./index.html" title="retour">Retour</a>
    </div>

    <div class="card my-4">
      <div v-if="!show_success" class="card-header" id="collapseButton">
        <h5 class="mb-0">
          <button class="btn btn-link text-primary"
                  data-toggle="collapse" data-target="#collapseAjoutEntr" aria-expanded="true" aria-controls="collapseAjoutEntr">
            Formulaire d'ajout d'entreprise
          </button>
        </h5>
      </div>

      <div id="collapseAjoutEntr" class="collapse show" aria-labelledby="collapseButton">
        <div v-if="!show_success" class="card-body">

          <div class="border-bottom mb-4">
            <h3>Ajout entreprise</h3>
          </div>

          <!-- Form Group -->
          <div class="form-group">
            <label for="numero_siret" class="input-label">Numéro de siret </label>
            <input v-model="siret" @change="siret_info()" type="text" class="form-control" name="numero_siret" id="numero_siret" placeholder="000-000-000-00000" aria-label="siret">
          </div>
          <!-- End Form Group -->

          <div class="row">
            <div class="col-sm-6">
              <!-- Form Group -->
              <div class="form-group">
                <label for="nom_entreprise2" class="input-label">Nom entreprise</label>
                <input v-model="nom_entreprise" type="text" class="form-control" name="nom_entreprise2" id="nom_entreprise2" placeholder="Entreprise" aria-label="nom_entreprise">
              </div>
              <!-- End Form Group -->
            </div>

            <div class="col-sm-6">
              <!-- Form Group -->
              <div class="form-group">
                <label for="activite" class="input-label">Activité de l'entreprise</label>
                <input v-model="activite" type="text" class="form-control" name="activite" id="activite" placeholder="Education" aria-label="Education">
              </div>
              <!-- End Form Group -->
            </div>
          </div>
          <!-- End Row -->

          <!-- Form Group -->
          <div class="form-group">
            <label for="mail_entreprise" class="input-label">Mail de l'entreprise</label>
            <input v-model="mail_entreprise" type="email" class="form-control" name="mail_entreprise" id="mail_entreprise" placeholder="mail@entreprise.fr" aria-label="mail_entreprise">
          </div>
          <!-- End Form Group -->

          <div class="row">
            <div class="col-sm-6">
              <!-- Form Group -->
              <div class="form-group">
                <label for="date_stagiaire" class="input-label">Date du dernier stagiaire</label>
                <input v-model="date_stagiaire" type="date" class="form-control" name="date_stagiaire" id="date_stagiaire" placeholder="01/02/2022" aria-label="01/02/2022">
              </div>
              <!-- End Form Group -->
            </div>

            <div class="col-sm-6">
              <!-- Form Group -->
              <div class="form-group">
                <label for="nom_stagiaire" class="input-label">Nom du stagiare</label>
                <input v-model="nom_stagiaire" type="text" class="form-control" name="nom_stagiaire" id="nom_stagiaire" placeholder="Jean Dupont" aria-label="Jean Dupont">
              </div>
              <!-- End Form Group -->
            </div>
          </div>

          <div class="row">
            <div class="col-sm-6">
              <!-- Form Group -->
              <div class="form-group">
                <label for="prof_contact" class="input-label">Professeur en contact avec l'entreprise</label>
                <input v-model="professeur_contact" type="text" class="form-control" name="prof_contact" id="prof_contact" placeholder="Jeanne Calmant" aria-label="Jeanne Calmant">
              </div>
              <!-- End Form Group -->
            </div>

            <div class="col-sm-6">
              <div class="js-form-message form-group">
                <label class="input-label" for="transactions">Montant des transactions avec l’entreprise</label>
                <div class="input-group">
                  <input v-model="montant_transactions" type="number" class="form-control" name="transactions" id="transactions"
                         aria-label="transactions">
                  <div class="input-group-append">
                    <div class="input-group-text">€</div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        <div v-else id="add_success" class="card-body">
          <div class="d-flex align-items-center ">
            <i class="fa fa-check bg-success text-light p-2 avatar-circle mr-2"></i>
            <h3 class="text-success">Ajout d'entreprise réussi</h3>
          </div>
          <p>Vous pouvez à tout moment consulter vos documents, cliquer sur ce lien.</p>
        </div>

        <!-- Footer -->
        <div class="card-footer">
          <div v-if="!show_success" class="d-flex justify-content-end align-items-center">
            <button type="button" class="btn btn-primary" @click="addEtablissement()">
              Valider <i class="fas fa-angle-right ml-1"></i>
            </button>
          </div>

          <div v-else class="d-flex justify-content-end align-items-center">
            <button type="button" class="btn btn-primary" @click="show_success = false">
              Ajouter une autre entreprise <i class="fa fa-plus ml-1"></i>
            </button>
          </div>
        </div>
        <!-- End Footer -->
      </div>
    </div>

    <!-- Card -->
    <div class="card my-4">
      <!-- Header -->
      <div class="card-header">
        <h5 class="card-header-title">Liste des entreprises à solliciter</h5>
      </div>
      <!-- End Header -->

      <!-- Table -->
      <div class="table-responsive space-bottom-1" id="liste_entreprise">
        <table class="table table-borderless table-thead-bordered table-nowrap table-align-middle">
          <thead class="thead-light">
          <tr class="align-middle">
            <th>Nom de l'entreprise</th>
            <th>Siret entreprise</th>
            <th>Activité de l’entreprise</th>
            <th>Mail de l’entreprise</th>
            <th>Date du dernier stage</th>
            <th>Montant</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="etab in etablissements">
            <td>{{ etab.nom_entreprise }}</td>
            <td>{{ etab.siret }}</td>
            <td><span class="badge badge-soft-info">{{ etab.activite }}</span></td>
            <td><a class="btn btn-xs btn-info" :href="'mailto:' + etab.mail_entreprise">
              <i class="fas fa-phone mr-1"></i> Contacter l'entreprise</a>
            </td>
            <td>{{ etab.date_stagiaire }}</td>

            <td>
              <h3>
                <span class="badge badge-info" data-tooltip="tooltip" data-placement="top" :data-original-title="etab.montant_transactions + '€'">
                  <i class="fas fa-eye mr-1"></i> Voir le montant</span>
              </h3>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
<!--      <a href="./form-taxe.html" class="btn btn-info">Ajouter une entreprise</a>-->

      <!-- End Table -->
    </div>
    <!-- End Card -->
  </div>
</template>

<script>
export default {
  name: "DlnkTaxeSoliciterEntreprise",

  data: function () {
    return {

      etablissements: [],
      currentUAI: "",
      currentEtablissement: "",
      alert_msg: "",

      siret: "",
      nom_entreprise: "",
      activite: "",
      mail_entreprise: "",
      date_stagiaire: "",
      nom_stagiaire: "",
      professeur_contact: "",
      montant_transactions: "",

      show_success: false,
    }
  },

  methods: {

    siret_info: async function () {
      const _this = this

      if (_this.siret.length !== 14) {
        _this.invalid_siret = true
        return false
      }

      _this.invalid_siret = false

      const api_url = "https://entreprise.data.gouv.fr/api/sirene/v3/etablissements/" + _this.siret

      //NOM + ACTIVITE + MAIL
      axios.get(api_url)
          .then(function (response) {
            _this.siret_details = response.data
            _this.nom_entreprise = _this.siret_details.etablissement.unite_legale.denomination
          })
          .catch(function (error) {
            console.log(error)
          })
          .then(function () {
                // always executed
              }
          );
    },

    addEtablissement: function()
    {
      let newEtablissement = new Object();
      newEtablissement.siret = this.siret;
      newEtablissement.nom_entreprise = this.nom_entreprise;
      newEtablissement.activite = this.activite;
      newEtablissement.mail_entreprise = this.mail_entreprise;
      newEtablissement.date_stagiaire = this.date_stagiaire;
      newEtablissement.montant_transactions = this.montant_transactions;

      this.etablissements.push(newEtablissement);

      this.siret = "";
      this.nom_entreprise = "";
      this.activite = "";
      this.mail_entreprise = "";
      this.date_stagiaire = "";
      this.montant_transactions = "";

      this.nom_stagiaire = "";
      this.professeur_contact = "";

      this.show_success = true;
    },
  }
}
</script>

<style scoped>

#liste_entreprise td{
  vertical-align: middle;
}

#collapseButton button{
  font-size: 1.3rem;
  font-weight: 600;
  margin: 0;
  padding: 0;
}

#collapseButton button:hover{
  background-color: #DDDDFF;
}
</style>